export enum DataTestId {
  ANSWER_BUTTON = 'answer-button',
  MULTIPLE_ANSWER_BUTTON = 'multiple-answer-button',
  NEXT_BUTTON = 'next-button',
  SUBMIT_BUTTON = 'submit-button',
  SKIP_BUTTON = 'skip-button',
  BACK_BUTTON = 'back-button',
  CANCEL_BUTTON = 'cancel-button',
  CONFIRM_BUTTON = 'confirm-button',
  YES_BUTTON = 'yes-button',
  NO_BUTTON = 'no-button',
  TRY_AGAIN_BUTTON = 'try-again-button',
  QUESTION_MODAL_CLOSE_BUTTON = 'question-modal-close-button',

  POLICY_CHECKBOX = 'policy-checkbox',
  PLACE_INPUT = 'place-input',
  PLACE_LIST_ITEM = 'place-list-item',
  EMAIL_INPUT = 'email-input',
  EMAIL_LIST_ITEM = 'email-list-item',
  NAME_INPUT = 'name-input',

  PROGRESS_PERCENTAGE = 'progress-percentage',

  // trial payment
  GET_REPORT_BUTTON = 'get-report-button', // the button opens the payment modal
  // palmistry
  TAKE_PHOTO_BUTTON = 'take-photo-button',
  OPEN_SCAN_BUTTON = 'open-scan-button',
  // upsells
  GET_UPSELL_BUTTON = 'get-upsell-button',
  GET_CREDITS_UPSELL_BUTTON = 'get-credits-button',
  UPSELL_RADIO_BUTTON = 'upsell-radio-button',
  UPSELL_RADIO_BUTTON_LABEL = 'upsell-radio-button-label',
  // trial choice templates
  TRIAL_CHOICE_RADIO_BUTTON_LABEL = 'trial-choice-radio-button-label',
  // zodiac
  ZODIAC_ITEM_LIST = 'zodiac-item-list',

  ADD_TO_CART_BUTTON = 'add-to-cart-button',
}
